import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
/*import { ToastContainer } from 'react-toastify';*/

import App from "./App";
import store from "./App/store/index.js";
import { unregister } from "./registerServiceWorker";

import "./index.css";
import "react-toastify/dist/ReactToastify.min.css";

window._confirm = null;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,

  document.getElementById("root")
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js